export default [
  {
    title: "Setting",
    iconClassName: "SettingFilled",
    showSider: true,
    path: "/unifyDrop/setting",
    children: [
      {
        title: "BaseInfo",
        iconClassName: "dote",
        showSider: true,
        path: "/unifyDrop/setting/personalInfo",
        component: () => import("../pages/setting/personalInfo"),
      },
      {
        title: "AccountSecurity",
        iconClassName: "dote",
        showSider: true,
        path: "/unifyDrop/setting/accountSecurity",
        component: () => import("../pages/setting/accountSecurity"),
      },
      {
        title: "IOSSSetting",
        iconClassName: "dote",
        showSider: true,
        path: "/unifyDrop/setting/IOSS",
        component: () => import("../pages/setting/IOSSSetting"),
      },
      {
        title: "SystemSetting",
        ename: "System Setting",
        iconClassName: "dote",
        showSider: true,
        path: "/unifyDrop/setting/SystemSetting",
        component: () => import("../pages/setting/systemSetting"),
      },
    ],
  },
];
